(function ($, Global) {
    function StaticQSNPage() {
        // Déclaration class objet
    }

    StaticQSNPage.prototype.initEvents = function () {
		this.publishers();
	}

    StaticQSNPage.prototype.publishers = function () {
        $('body').scrollspy({ target: '#navigation', offset: 350 })

        $(document).on('shown.bs.collapse', '.card-portrait', function () {
            var $this = $(this);
            var scrollTop = $this.offset().top - 100;
            var name = $this.data('tag');

            var data = {
                RequestedPage: 1,
                searchQuerry: name,
                NombreDeResultatsParPage: 15,
                IsQSNPage: true,
                Publication: ['LLA']
            };
            if (!$this.find('.list-last-articles').exists() && name != '') {
                $.ajaxPost('/LLA/ajax/recherche/all', data)
                    .done(function (result) {
                        if (result.data.html != '') $this.find('.card-footer').append(result.data.html);
                    });
            }
            $('#listPersons').addClass('show-details')

            $('html, body').stop().animate({
                scrollTop: scrollTop
            }, 'slow');
                        
        });
        $(document).on('hide.bs.collapse', '.card-portrait', function () {
            $('#listPersons').removeClass('show-details');
        });
    }

    Global.StaticQSNPage = StaticQSNPage;
}(jQuery, window));